import { AnchorProvider } from "@project-serum/anchor";
import { Connection } from "@solana/web3.js";

// Actions
import { setConnection, setProvider } from "../store/reducers/connectSlice";

// Config
import { COMMITMENT, NETWORK_ENDPOINT } from "../config";

export const getInitialConnection = wallet => (dispatch, getState) => {
  const opts = {
    preflightCommitment: COMMITMENT,
  };
  const stateConnection = getState().connect.connection;
  const mainnet = `https://solana-api.syndica.io/access-token/neOAOspmaDZY0EgzgTupAt71xJWEljkdvgYxzgppXqu3arBsFBAI1UiaOm5Q00Ja/rpc`;
  const connection = stateConnection || new Connection(mainnet, opts.preflightCommitment);

  if (!stateConnection) {
    dispatch(setConnection(connection));
  }

  const provider = new AnchorProvider(connection, wallet, opts);

  dispatch(setProvider(provider));
};
